<div class="si-vertical-menu {{styleClass}}">
  <div class="si-vertical-menu_search" *ngIf="!hideSearch" [(siClickOutsideClose)]="showSearchContainer">
    <div class="d-flex align-items-center">
      <input type="text"
             id="verticalMenuSearchInput"
             name="verticalMenuSearchInput"
             class="si-vertical-menu_search_input"
             autocomplete="off"
             placeholder="Buscador"
             [(ngModel)]="searchModel"
             (ngModelChange)="onChangeSearchModel()"
             (focus)="onFocusSearchInput()">
      <i class="icon-search2 si-vertical-menu_search_icon"></i>
    </div>
    <div class="si-vertical-menu_search_container si-scroll-thin" *ngIf="showSearchContainer && searchModel">
      <div *ngIf="!filteredItems?.length">{{'CORE_NO_RESULTS' | translate}}</div>
      <div [siHighlight]="highlightSearchModel">
        <ng-template ngFor [ngForOf]="filteredItems" [ngForTemplate]="siVerticalMenuSearchItem"></ng-template>
        <ng-template #siVerticalMenuSearchItem let-item>
          <div [hidden]="item.hide" class="si-vertical-menu_search_container_item">
            <i class="icon-stepforward si-vertical-menu_search_container_item_icon"></i>
            <ng-container *ngIf="item.routerLink; else noLink">
              <a class="si-vertical-menu_search_container_item_link"
                 [routerLink]="item.routerLink"
                 (click)="onClickSearchLink(item)">
                {{item.label}}
              </a>
            </ng-container>
            <ng-template #noLink>
              <span class="si-vertical-menu_search_container_item_label">{{item.label}}</span>
            </ng-template>
          </div>
          <div *ngIf="item.items?.length" class="si-vertical-menu_search_container_child">
            <ng-template ngFor [ngForOf]="item.items" [ngForTemplate]="siVerticalMenuSearchItem"></ng-template>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div *ngFor="let item of items" [hidden]="item.hide" [tourAnchor]="item.anchorId" class="si-vertical-menu_panel" [class.leaf]="!item.items?.length">
    <div class="si-vertical-menu_panel_header">
      <ng-container *ngTemplateOutlet="siVerticalMenuTitle; context: {item: item}"></ng-container>
    </div>
    <div *ngIf="item.items?.length"
         class="si-vertical-menu_panel_content"
         [@submenu]="item.expanded ? {value: 'visible'} : {value: 'hidden'}">
      <ng-template ngFor [ngForOf]="item.items" [ngForTemplate]="siVerticalMenuItem"></ng-template>
    </div>
  </div>

  <ng-template #siVerticalMenuItem let-item>
    <div [hidden]="item.hide" [tourAnchor]="item.anchorId" class="si-vertical-menu_panel_content_item"
         [class.leaf]="!item.items?.length"
         [class.active]="item.active">
      <ng-container *ngTemplateOutlet="siVerticalMenuTitle; context: {item: item}"></ng-container>
      <div *ngIf="item.items?.length"
           class="si-vertical-menu_panel_content_item_container"
           [@submenu]="item.expanded ? {value: 'visible'} : {value: 'hidden'}">
        <ng-template ngFor [ngForOf]="item.items" [ngForTemplate]="siVerticalMenuItem"></ng-template>
      </div>
    </div>
  </ng-template>

  <ng-template #siVerticalMenuTitle let-item="item">
    <ng-container *ngIf="item.routerLink; else noLink">
      <a [routerLink]="item.routerLink"
         class="si-vertical-menu_panel_title"
         [class.active]="item.active"
         (click)="onClickItem($event, item)">
        <i class="{{item.icon}} si-vertical-menu_panel_title_icon" *ngIf="item.icon"></i>
        <div class="si-vertical-menu_panel_title_link">{{item.label}}</div>
      </a>
    </ng-container>
    <ng-template #noLink>
      <div class="si-vertical-menu_panel_title"
           [class.active]="item.active"
           (click)="onClickItem($event, item)">
        <i class="{{item.icon}} si-vertical-menu_panel_title_icon" *ngIf="item.icon"></i>
        <div class="si-vertical-menu_panel_title_link">{{item.label}}</div>
        <i *ngIf="item.items?.length"
           class="si-vertical-menu_panel_title_expand"
           [class.expanded]="item.expanded"
        ></i>
      </div>
    </ng-template>
  </ng-template>
</div>
